import { AppService } from "app/services/app.service";

import { ChamadoDto } from "app/models/chamado-dto.model";
import { RespostaChamadoDto } from "app/models/resposta-chamado-dto.model";
import { Observable } from "rxjs";

export abstract class AbChamado extends AppService {
  abstract getAllCategoriasChamados(filter: string): Observable<any>;
  abstract saveCategoriaChamado(categoriaChamado: any): Observable<any>;
  abstract deleteCategoriaChamado(entityId: number);
  abstract getAllCategoriaChamado();
  abstract getAllChamadosFilter(filter: string): Observable<any>;
  abstract deleteChamado(entityId: number);
  abstract getChamadoById(id:number, checkId: number): Observable<any>
  abstract saveChamado(chamado: ChamadoDto): Observable<any>;
  abstract downloadAnexoChamado(id: number, nomeAnexo: string): Observable<any>;
  abstract deleteAnexoChamado(id: number): Observable<any>;
  abstract getRespostaChamados(idChamado: number, checkId: number): Observable<any>;
  abstract saveRespostaChamado(resposta: RespostaChamadoDto): Observable<any>;
  abstract getRelatorioId(id: number, checkId: number): Observable<any>;
  abstract getListarRelatorio(filter: string): Observable<any>;
  abstract getRelatorio(filter: string, tipo: string): Observable<any>;
}
